import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { find, last, reduce, map, filter } from 'lodash'

import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder, makeGetOrderPreferencesByOrder, getPaymentByOrder } from '../../../selectors/suites'
import { getPrinters } from '../../../selectors/printer'
import { getReceiptPrinterUuid } from '../../../selectors/config'
import { getPeripheralStatus } from '../../../selectors/peripheral'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'
import { printOrder, fetchPrinters } from '../../../actions/printer'

import CloseTender from '../../../components/tabs/OrderDetailsModal/CloseTender'

import { addTenderOnOrder } from '../../../actions/order'
import { formatPayments } from '../../../utils/filterValidPayments'
import { makeGetActiveRevenueCenter, makeGetNoOpTenders } from '../../../selectors/revenueCenter'

const getTenderAmountInCents = (order, paymentId) => {
  const currentPayment = find(order?.payments, (payment) => {
    return payment?.uuid === paymentId
  })
  return currentPayment?.amountInCents ?? 0
}

// Remove payments that are payment preferences and cash orders
const removeInvalidPayments = (payments = []) => {
  const paymentIds = {}
  const validPayments = payments?.filter(payment => payment.amountInCents > 0)

  const uniquePayments = filter(validPayments, ({ amountInCents, paymentType, userAttributes, shortDescription }) => {
    const id = userAttributes?.token
    const isDuplicate = !!paymentIds[id] || paymentType === 'direct_bill'

    if (!isDuplicate) {
      paymentIds[id] = shortDescription ?? true
    }

    const isCash = paymentType === 'cash'
    return !(isDuplicate || isCash)
  })

  return uniquePayments
}

const mapStateToProps = (state, ownProps) => {
  const historyState = ownProps?.history?.location?.state
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)
  const paymentId = ownProps?.match?.params?.paymentId ?? last(order?.payments)?.uuid
  const tenderAmountInCents = historyState?.tenderAmountInCents || getTenderAmountInCents(order, paymentId)
  const isTenderUpdate = historyState?.isTenderUpdate
  const customerId = order?.customerId ?? ''
  const revenueCenterId = order?.revenueCenterUuid ?? ''
  const isOrderLatestFromServer = tabOrder?.latestFromServer ?? false
  const printers = getPrinters(state)
  const deviceReceiptPrinterUuid = getReceiptPrinterUuid(state)
  const orderTotalFromOrder = order?.orderTotalFromOrder
  const peripheralStatus = getPeripheralStatus(state)
  const cashEnabled = makeGetActiveRevenueCenter()(state)?.allowCashPaymentsOnPos ?? true
  const noOpPayments = makeGetNoOpTenders()(state)
  let payments = removeInvalidPayments(formatPayments(order.payments))

  // TODO: We need to find a long term solution for this.
  if (order.payments?.length === 1 && payments?.[0]) {
    payments[0].shortDescription = order.payment
  }


  return {
    ...order,
    payments,
    customerId,
    isOrderLatestFromServer,
    noOpPayments,
    paymentId,
    printers,
    orderTotalFromOrder,
    revenueCenterId,
    suiteInformation,
    deviceReceiptPrinterUuid,
    peripheralStatus,
    tenderAmountInCents,
    isTenderUpdate,
    cashEnabled,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const historyState = ownProps?.history?.location?.state
  const tenderAmountInCents = historyState?.tenderAmountInCents ?? 0
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const replace = ownProps?.history?.replace ?? function(){}
  const push = ownProps?.history?.push ?? function(){}

  return {
    onClose: () => {
      replace('/tabs')
    },
    onPaymentSelect: (params) => {
      dispatch(addTenderOnOrder({ orderId, amountInCents: tenderAmountInCents, ...params }))
    },
    onCashPayment: (tenderAmountInCents) => {
      replace({
        pathname: `/change-calculator/${orderId}?tab`,
        state: {
        tenderAmountInCents: tenderAmountInCents,
        },
      })
    },
    fetchPrinters: () => dispatch(fetchPrinters()),
    onViewCheck: (paymentId) => push(`/signature/${orderId}/${paymentId}?action=close-tender`),
    printOrder: (params) => dispatch(printOrder(params)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CloseTender))
